import { render, staticRenderFns } from "./ResourcesPage.vue?vue&type=template&id=45221826&scoped=true"
import script from "./ResourcesPage.vue?vue&type=script&lang=ts"
export * from "./ResourcesPage.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesPage.vue?vue&type=style&index=0&id=45221826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45221826",
  null
  
)

export default component.exports